import { memo, createElement } from 'react';
import classNames from 'classnames'
import _isEqual from 'lodash/isEqual';

export default memo(({ elType = 'h4', discountElType = 'h5', priceFirst = false, className, discountClassName, finalPrice, price, addBreak, addSpace, discountPreffix, suffix, ...props }) => {
	if (!_isEqual(price, finalPrice)) {
		if(priceFirst){
			return(
				<>
					{
						createElement(
							elType,
							{
								className: classNames('', className),
								...props
							},
							suffix ? `${finalPrice} / ${suffix}` : finalPrice
						)
					}
					{addBreak && (<br />)}
					{
						createElement(
							discountElType,
							{
								className: classNames(discountClassName, {
									'': !addBreak
								}),
								style: { textDecoration: 'line-through' }
							},
							price
						)
					}
				</>
			)
		} else{
			return (
				<>
					{
						createElement(
							discountElType,
							{
								className: classNames(discountClassName, {
									'mr-3': !addBreak
								}),
								style: { textDecoration: 'line-through' }
							},
							price
						)
					}
					{addBreak && (<br />)}
					{addSpace && (<>&nbsp;</>)}
					{
						createElement(
							elType,
							{
								className: classNames('text-danger', className),
								...props
							},
							suffix ? `${finalPrice} / ${suffix}` : finalPrice
						)
					}
				</>
			)
		}		
	}

	return createElement(
		elType,
		{
			className: classNames('text-danger', className),
			...props
		},
		suffix ? `${finalPrice} / ${suffix}` : finalPrice
	)
})
